import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
import {
  userSelector,
  fetchUserInfo,
  updateUserInfo
} from 'slices/user';
//components
import TitleWithLine from 'components/titleWithLine';
import CustomTab from 'components/Tab';
import AccountData from './accountData';
import BenefitedBookStore from './benefitedBookStore';
import Addresses from './addresses';
//styles
import './profile.scss';

const Profile = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const userStatus = useSelector((state) => state.user.status);
  const { benefitedBookstore } = useSelector(userSelector);
  const { name } = useSelector(companySelector);
  const { t } = useTranslation(['register', 'header']);
  const [disableBtnSave, setDisableBtnSave] = useState(false);
  const [errorSave, setErrorSave] = useState('');
  const [successSave, setSuccessSave] = useState(false);
  const [successAddressSave, setSuccessAddressSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formInfo, setFormInfo] = useState({
    cif: '',
    name: '',
    last_name: '',
    email: '',
    birth_date: '',
    direccion_facturacion: {},
    direccion_envio: {},
    benefited_bookstore: benefitedBookstore || '',
  });
  const [updateData, setUpdateData] = useState({
    first_name: '',
    last_name: '',
    date_birth: '',
    email: '',
    dni: '',
    phone_number: '',
  });

  const defaultAddress = {
    address: '',
    country: { value: '', label: '' },
    email: '',
    first_name: '',
    last_name: '',
    locality: '',
    phone: '',
    postal_code: '',
    province: { value: '', label: '' },
  };

  const [updateDataAddress, setUpdateDataAddress] = useState({
    billing_address: defaultAddress,
  });

  const [updateDataShipping, setUpdateDataShipping] = useState({
    shipping_address: defaultAddress,
  });

  const setFormData = (data) => {
    setUpdateData({
      first_name: data?.firstName,
      last_name: data?.lastName,
      date_birth: data.dateBirth || '',
      email: data.email,
      dni: data.dni || '',
      phone_number: data.phoneNumber || '',
    });
    setUpdateDataAddress({
      billing_address: data?.billingAddress || defaultAddress,
    });
    setUpdateDataShipping({
      shipping_address: data?.shippingAddress || defaultAddress,
    });
    setFormInfo({
      cif: data?.dni || '',
      name: data?.firstName || '',
      last_name: data?.lastName || '',
      email: data.email || '',
      birth_date: data.dateBirth || '',
      direccion_facturacion: data.billingAddress || {},
      direccion_envio: data.shippingAddress || {},
      benefited_bookstore: data?.benefitedBookstore,
    });
  };

  useEffect(() => {

    if (userStatus === 'idle') {
      dispatch(fetchUserInfo());
    }
    if (userStatus === 'succeeded') {
      setFormData(userInfo);
    }
  }, [userStatus, userInfo, dispatch]);

  const handleSaveAddress = async (addressType, addressData) => {
    try {
      const province = addressData.province.label;
      const customData = {
        ...addressData,
        province: province
      }
      const addressInfo = {
        [addressType]: customData,
      };
      await dispatch(updateUserInfo({ data: addressInfo, id: userInfo.id })).unwrap();
      setSuccessSave(false);
      setSuccessAddressSave(true);
      dispatch(fetchUserInfo());
    } catch (error) {
      console.error('Error:', error);
      setErrorSave('Error message');
    } finally {
      setDisableBtnSave(false);
    }
  };

  const handleSaveDF = async () => {
    setDisableBtnSave(true);
    setErrorSave('');
    setSuccessAddressSave(false);
    await handleSaveAddress('billing_address', updateDataAddress?.billing_address);
  };

  const handleSaveDE = async () => {
    setDisableBtnSave(true);
    setErrorSave('');
    setSuccessAddressSave(false);
    await handleSaveAddress('shipping_address', updateDataShipping?.shipping_address);
  };

  useEffect(() => {
    if (userStatus === 'idle') {
      dispatch(fetchUserInfo());
    }
    window.document.title = `${t('myaccount', { ns: 'header' })} | ` + name;
    goUp();
  }, [dispatch, userStatus]);

  const recoverUserInfo = async () => {
    if (userStatus === 'idle') {
      dispatch(fetchUserInfo());
    }
  };

  useEffect(() => {
    recoverUserInfo();
  }, [userStatus, dispatch]);

  let time = null;
  let time2 = null;
  useEffect(() => {
    if (successSave) {
      time = setTimeout(() => setSuccessSave(false), 3000);
    }
    if (successAddressSave) {
      time2 = setTimeout(() => setSuccessAddressSave(false), 3000);
    }
    return () => {
      clearTimeout(time);
      clearTimeout(time2);
    };
  }, [successSave, successAddressSave]);

  const handleChangeSave = async () => {
    setDisableBtnSave(true);
    setErrorSave('');
    setSuccessAddressSave(false);
    setLoading(true);
    try {
      await dispatch(updateUserInfo({ data: formInfo, id: userInfo.id })).unwrap();
      dispatch(fetchUserInfo());
      setDisableBtnSave(false);
      setSuccessSave(true)
    } catch (e) {
      console.log(e);
      setErrorSave(t('errormessage', { ns: 'header' }));
      setDisableBtnSave(false);
      setSuccessSave(false)
    }
    setLoading(false);
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid mainDiv margin-progile">
      <Row>
        <Col md={12}>
          <TitleWithLine text={t('myaccount', { ns: 'header' })} />
        </Col>
      </Row>
      <Row className='tabs-row tab-profile'>
        <CustomTab
          customClass="custom-tab p-3 p-lg-0"
          tabs={[
            {
              title: t('accountdata', { ns: 'register' }),
              id: 'accountdata',
              renderContent: () => {
                return <AccountData
                  updateData={updateData}
                  setUpdateData={setUpdateData}
                  disableBtnSave={disableBtnSave} />
              },
            },
            {
              title: t('benefitedbookstore', { ns: 'register' }),
              id: 'benefitedbookstore',
              renderContent: () => {
                return <BenefitedBookStore
                  formInfo={formInfo}
                  setFormInfo={setFormInfo}
                  handleChangeSave={handleChangeSave}
                  errorSave={errorSave}
                  successSave={successSave}
                  loading={loading}
                />
              },
            },
            {
              title: t('billingaddress', { ns: 'register' }),
              id: 'billingaddress',
              renderContent: () => {
                return <Addresses
                  address='billing_address'
                  errorSave={errorSave}
                  successAddressSave={successAddressSave}
                  updateData={updateDataAddress}
                  setUpdateData={setUpdateDataAddress}
                  handleSave={handleSaveDF} />
              },
            },
            {
              title: t('shippingaddress', { ns: 'register' }),
              id: 'shippingaddress',
              renderContent: () => {
                return <Addresses
                  address='shipping_address'
                  errorSave={errorSave}
                  successAddressSave={successAddressSave}
                  updateData={updateDataShipping}
                  setUpdateData={setUpdateDataShipping}
                  handleSave={handleSaveDE} />
              },
            }
          ]}
        />
      </Row>
    </div>
  );
};

export default Profile;